import Cta from "../../../../src/components/Cta";
import * as React from 'react';
export default {
  Cta,
  React
};